import { requireStates } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);

const initialStates = [
  {
    name: "app.management",
    url: "/relatorios",
    abstract: true,
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    },
    data: {
      navigation: {
        priority: 200,
        name: "Relatórios"
      },
      authorization: () => true
    }
  }
];

const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/index.js